import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { SlideAction, SlideLayout, ViewMode } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate, useParams } from 'react-router-dom';
import { Asset as AssetOld } from './asset-old';
import { AssetCard } from './assetCard';
import { AssetComponent } from './assetComponent';
import { AssetFilters } from './assetFilters';
import { AssetsFilters } from './assetsFilters';

export const Asset = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  if (isCropCircleEnabled) {
    return <AssetBase />;
  }

  return (
    <View style={styles.container}>
      <AssetOld />
    </View>
  );
};

export const AssetBase = () => {
  const { assetId = '' } = useParams();
  const navigate = useNavigate();

  const leftColumn = (
    {
      title: 'assets.menu.title',
      mainComponent: (
        <AssetComponent />
      ),
      headerComponent: (
        <AssetsFilters />
      ),
      disableScroll: true,
    }
  );

  const rightColumn = (
    {
      title: 'assets.menu.title',
      mainComponent: (
        <AssetCard assetId={assetId} />
      ),
      headerComponent: (
        <AssetFilters 
          assetId={assetId}
        />
      ),
      showBackButton: true,
      backButtonTransition: SlideAction.SINGLE,
      onBackButtonPress: () => {
        navigate('/assets');
      }
    }
  );

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
});
